import React from "react";
import { Modal } from "melodies-source/Modal";
import { Body1, H2 } from "melodies-source/Text";
import { Button } from "melodies-source/Button";
import styled from "styled-components";
import { ReactComponent as CheckIcon } from "assets/svg/check-circle.svg";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const RequestSubmittedModal: React.FC<Props> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen}>
      <Container>
        <CheckIcon />
        <H2>Request Submitted</H2>
        <Body1>
          Your request was successfully submitted. A member of the SET team will
          be reaching out.
        </Body1>
        <Button onClick={onClose}>Close</Button>
      </Container>
    </Modal>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;

  & > svg {
    color: #3ec581;
  }

  ${Body1} {
    text-align: center;
    margin: 5px 0 20px;
  }

  button {
    min-width: 250px;
  }
`;
